/**
 * Header YASY: drawer do menu mobile e mini cart.
 *
 * Substitui o useDrawer()/useCartFetchers() do headless. O carrinho usa a
 * Cart AJAX API somada à Section Rendering API: cada alteração devolve o HTML
 * já renderizado da section `yasy-cart-drawer`, que troca o corpo do painel.
 */
(function () {
  var SECTION_CART = 'yasy-cart-drawer';

  // ---------------------------------------------------------------- utilidades
  function $(sel, raiz) { return (raiz || document).querySelector(sel); }
  function $$(sel, raiz) { return Array.prototype.slice.call((raiz || document).querySelectorAll(sel)); }

  var DURACAO = 350;
  var SUAVE = 'cubic-bezier(0.32, 0.72, 0, 1)';

  function movimentoReduzido() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  /**
   * Anima o painel e o fundo escuro.
   * Usa a Web Animations API em vez de transição CSS porque o painel sai de
   * `display: none` a cada abertura — nesse caso uma transição de `transform`
   * fica presa no valor inicial e o painel surge de uma vez, já no lugar.
   */
  function animar(drawer, entrando) {
    var painel = drawer.querySelector('[data-yasy-painel]');
    var fundo = drawer.querySelector('[data-yasy-drawer-fundo]');
    var duracao = movimentoReduzido() ? 0 : DURACAO;

    var lado = painel && painel.getAttribute('data-yasy-painel') === 'esquerda' ? '-100%' : '100%';
    var deFora = 'translateX(' + lado + ')';
    var noLugar = 'translateX(0)';

    var animacoes = [];
    if (painel && painel.animate) {
      animacoes.push(painel.animate(
        entrando ? [{transform: deFora}, {transform: noLugar}] : [{transform: noLugar}, {transform: deFora}],
        {duration: duracao, easing: SUAVE, fill: 'forwards'}
      ));
    }
    if (fundo && fundo.animate) {
      animacoes.push(fundo.animate(
        entrando ? [{opacity: 0}, {opacity: 1}] : [{opacity: 1}, {opacity: 0}],
        {duration: duracao, easing: 'ease', fill: 'forwards'}
      ));
    }
    return animacoes;
  }

  function abrir(drawer, botao) {
    if (!drawer) return;
    if (drawer.dataset.fechando) {
      clearTimeout(parseInt(drawer.dataset.fechando, 10));
      delete drawer.dataset.fechando;
    }
    drawer.hidden = false;
    drawer.setAttribute('data-aberto', '');
    animar(drawer, true);
    document.body.style.overflow = 'hidden';
    if (botao) botao.setAttribute('aria-expanded', 'true');
    var focavel = drawer.querySelector('button, a, input');
    if (focavel) focavel.focus();
  }

  function fechar(drawer, botao) {
    if (!drawer || drawer.hidden) return;
    drawer.removeAttribute('data-aberto');
    animar(drawer, false);
    document.body.style.overflow = '';
    if (botao) botao.setAttribute('aria-expanded', 'false');
    var id = setTimeout(function () {
      drawer.hidden = true;
      delete drawer.dataset.fechando;
    }, movimentoReduzido() ? 0 : DURACAO);
    drawer.dataset.fechando = String(id);
  }


  // -------------------------------------------------------------- menu mobile
  function ligarMenu() {
    var painel = $('[data-yasy-menu-drawer]');
    var botao = $('[data-yasy-menu-abrir]');
    if (!painel || !botao) return;

    botao.addEventListener('click', function () { abrir(painel, botao); });
    $$('[data-yasy-menu-fechar]', painel).forEach(function (b) {
      b.addEventListener('click', function () { fechar(painel, botao); });
    });
  }

  // ------------------------------------------------------------------ minicart
  function painelCart() { return $('[data-yasy-cart-drawer]'); }

  function atualizarContador(quantidade) {
    $$('[data-yasy-cart-contador]').forEach(function (el) {
      el.textContent = quantidade;
      el.classList.toggle('hidden', quantidade === 0);
    });
  }

  function ocupado(estado) {
    var corpo = $('[data-yasy-cart-corpo]');
    if (corpo) corpo.style.opacity = estado ? '0.5' : '';
  }

  /** Troca o corpo do painel pelo HTML devolvido pela Section Rendering API. */
  function aplicarSection(html) {
    var corpo = $('[data-yasy-cart-corpo]');
    if (!corpo || !html) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    // a section vem embrulhada; pega o conteúdo útil
    var novo = doc.querySelector('.shopify-section') || doc.body;
    corpo.innerHTML = novo.innerHTML;
  }

  function pedir(url, corpoJson) {
    ocupado(true);
    return fetch(url, {
      method: 'POST',
      headers: {'Content-Type': 'application/json', Accept: 'application/json'},
      body: JSON.stringify(Object.assign({sections: SECTION_CART}, corpoJson))
    })
      .then(function (r) { return r.json(); })
      .then(function (dados) {
        if (dados.sections && dados.sections[SECTION_CART]) aplicarSection(dados.sections[SECTION_CART]);
        var qtd = typeof dados.item_count === 'number' ? dados.item_count : null;
        if (qtd === null) return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) { atualizarContador(c.item_count); });
        atualizarContador(qtd);
      })
      .catch(function (e) { console.error('[yasy-cart]', e); })
      .then(function () { ocupado(false); });
  }

  function alterar(chave, quantidade) { return pedir('/cart/change.js', {id: chave, quantity: quantidade}); }

  function ligarCart() {
    var painel = painelCart();
    if (!painel) return;

    $$('[data-yasy-cart-abrir]').forEach(function (b) {
      b.addEventListener('click', function () { abrir(painel, b); });
    });

    // delegação: o conteúdo é substituído a cada alteração
    painel.addEventListener('click', function (e) {
      var fecha = e.target.closest('[data-yasy-cart-fechar]');
      if (fecha) { fechar(painel); return; }

      var remove = e.target.closest('[data-yasy-cart-remover]');
      if (remove) { alterar(remove.getAttribute('data-yasy-cart-remover'), 0); return; }

      var qtd = e.target.closest('[data-yasy-cart-quantidade]');
      if (qtd && !qtd.disabled) {
        alterar(qtd.getAttribute('data-yasy-cart-quantidade'), parseInt(qtd.getAttribute('data-valor'), 10));
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { fechar(painel); fechar($('[data-yasy-menu-drawer]'), $('[data-yasy-menu-abrir]')); }
    });

    // adicionar ao carrinho abre o painel, como o useCartFetchers fazia
    document.addEventListener('submit', function (e) {
      var form = e.target.closest('form[action$="/cart/add"]');
      if (!form) return;
      e.preventDefault();
      var dados = new FormData(form);
      dados.append('sections', SECTION_CART);
      ocupado(true);
      fetch('/cart/add.js', {method: 'POST', headers: {Accept: 'application/json'}, body: dados})
        .then(function (r) { return r.json(); })
        .then(function (resposta) {
          if (resposta.status) { console.error('[yasy-cart]', resposta.description || resposta.message); return; }
          if (resposta.sections && resposta.sections[SECTION_CART]) aplicarSection(resposta.sections[SECTION_CART]);
          return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
            atualizarContador(c.item_count);
            abrir(painel);
          });
        })
        .catch(function (err) { console.error('[yasy-cart]', err); })
        .then(function () { ocupado(false); });
    });
  }

  // ------------------------------------------------------- busca no celular
  function ligarBusca() {
    var camada = $('[data-yasy-busca-camada]');
    var abrirBtn = $('[data-yasy-busca-abrir]');
    if (!camada || !abrirBtn) return;

    var campo = camada.querySelector('[data-yasy-busca-campo]');
    var fecharBtn = camada.querySelector('[data-yasy-busca-fechar]');

    function anima(entrando) {
      if (!camada.animate || movimentoReduzido()) return;
      camada.animate(
        entrando ? [{transform: 'translateX(-100%)', opacity: 0}, {transform: 'translateX(0)', opacity: 1}]
                 : [{transform: 'translateX(0)', opacity: 1}, {transform: 'translateX(-100%)', opacity: 0}],
        {duration: 260, easing: SUAVE, fill: 'forwards'}
      );
    }

    function abrirBusca() {
      if (camada.dataset.fechando) { clearTimeout(parseInt(camada.dataset.fechando, 10)); delete camada.dataset.fechando; }
      camada.hidden = false;
      anima(true);
      abrirBtn.setAttribute('aria-expanded', 'true');
      if (campo) campo.focus();
    }

    function fecharBusca() {
      if (camada.hidden) return;
      anima(false);
      abrirBtn.setAttribute('aria-expanded', 'false');
      if (campo) campo.value = '';
      var id = setTimeout(function () {
        camada.hidden = true;
        delete camada.dataset.fechando;
      }, movimentoReduzido() ? 0 : 260);
      camada.dataset.fechando = String(id);
      abrirBtn.focus();
    }

    abrirBtn.addEventListener('click', abrirBusca);
    if (fecharBtn) fecharBtn.addEventListener('click', fecharBusca);
    camada.addEventListener('keydown', function (e) { if (e.key === 'Escape') fecharBusca(); });
  }

  function iniciar() { ligarMenu(); ligarCart(); ligarBusca(); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar);
  else iniciar();
  document.addEventListener('shopify:section:load', iniciar);
})();
